export const SPECIAL_VEHICLE_MODELS = {
  MACH_E: 'Mustang Mach-E',
} as const

export const VEHICLE_NOTES = {
  MACH_E_PUCK: 'MUST USE MACH-E PUCK.',
} as const
